import { memo, useCallback, type JSX } from "react";

import { IconImageFileLandscape } from "@mobsuccess-devops/icons/image-file-landscape";
import { HStack } from "@mobsuccess-devops/styled-system/jsx";

import mobyFullBodyTransparent from "../../assets/moby-full-body-transparent.png";
import { useLocales } from "../../features/localization";
import { Button } from "../Button";
import { ButtonLink } from "../Button/ButtonLink";
import { Image } from "../Image";
import { Typo } from "../Typo";
import { Progress } from "../_PandaArk/Progress";

import { styles } from "./styles";

function AnyErrorPage(): JSX.Element {
  const classes = styles();
  const { errorPage } = useLocales();

  const handleGoBack = useCallback(() => {
    window.history.back();
  }, []);

  return (
    <div className={classes.layout}>
      <div className={classes.imageContainer}>
        <Image.Root>
          <Image.Img
            src={mobyFullBodyTransparent}
            alt="Moby"
            className={classes.image}
          />
          <Image.Fallback borderRadius="md" size="120px">
            <IconImageFileLandscape variant="regular" size="full" />
          </Image.Fallback>
          <Image.Loader>
            <Progress.Circular size="md" value="indeterminate" />
          </Image.Loader>
        </Image.Root>
      </div>
      <div className={classes.content}>
        <Typo.Title
          fontSize="32px"
          color="interface.600"
          className={classes.text}
        >
          {errorPage.title}
        </Typo.Title>
        <Typo.Body color="interface" className={classes.text}>
          {errorPage.description}
          <br />
          {errorPage.contactSupport}
        </Typo.Body>
        <HStack>
          <Button
            variant="outlined"
            palette="interface"
            onClick={handleGoBack}
            hidden={window.history.length <= 1}
          >
            {errorPage.goBack}
          </Button>
          <ButtonLink variant="dark" palette="interface" to="/">
            {errorPage.goHome}
          </ButtonLink>
        </HStack>
      </div>
    </div>
  );
}

const MemoizedComponent = memo(AnyErrorPage);
export { MemoizedComponent as AnyErrorPage };
